import { render, staticRenderFns } from "./dashboardBar.vue?vue&type=template&id=a83f4758&scoped=true"
import script from "./dashboardBar.vue?vue&type=script&lang=js"
export * from "./dashboardBar.vue?vue&type=script&lang=js"
import style0 from "./dashboardBar.vue?vue&type=style&index=0&id=a83f4758&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a83f4758",
  null
  
)

export default component.exports